const getPatientDefaultParams = () => {

	let default_patient = {
    'Patient_Data': {

      // IDENTIFICATION
      'id_patient': "", 
      'serialNumber': "", // to be removed
            'firstname': "",
            'lastname': "",
      'birthdate': "1990-1-1",
    	    'share_info' : {
    	    	'owner': "", 
    	    	'structure_shared': {
    	    		'name': "",
    	    		'id': ""
    	},
      },
      "INS_Data":{},  // opt

      // Group & location
      'group': {id_group: "null", group_name: 'No group', description: 'For patient without group'},
      'location': '',

      // CORRESPONDANT (opt)
      'FK_Correspondant': '',

      // ACTIVATION FLAG
      "monitoring_activation": "no",

      // DEVICES
    	    'devices': {
    	        'device1': {
    	            'id': '',
    	            'id_old': '',
    	            'type': '',
    	            'nickname': '',
    	            'sn': ''
    	        },
              'device2': {
                  'id': '',
                  'id_old': '',
                  'type': '',
                  'nickname': '',
                  'sn': ''
              },
              'device3': {
                  'id': '',
                  'id_old': '',
                  'type': '',
                  'nickname': '',
                  'sn': ''
              },
              'device4': {
                  'id': '',
                  'id_old': '',
                  'type': '',
                  'nickname': '',
                  'sn': ''
              },              
              'device5': {
                  'id': '',
                  'id_old': '',
                  'type': '',
                  'nickname': '',
                  'sn': ''
              },
    	        'gateway': {
    	            'id': '',
    	            'id_old': '',
    	            'name': '',
    	            'nickname': ''
    	        }
    	    },
      // ALERTS
    	    "alerts": {
  	        "fever_alert": {
  	          "activated": "",
  	          "threshold": "",
  	          "sup_or_inf": "",
  	          "delay": "",
              "trig_duration": "",
              "rest_duration": "",
  	          "last_alert": "",
  	          "triggered": "",
  	          "threshold_exceeded_count": "",
  	          "threshold_exceedance_window": "",
  	          "threshold_exceedance_period": "",
  	          "last_period_alert": ""
  	        },
            'detach_alert':  {
              "activated": "",
              "threshold": "",
              "sup_or_inf": "",
              "delay": "",
              "trig_duration": "",
              "rest_duration": "",
              "last_alert": "",
              "triggered": ""
            },  
            'battery_alert': {
              "activated": "",
              "threshold": "",
              "sup_or_inf": "",
              "delay": "",
              "trig_duration": "",
              "rest_duration": "",
              "last_alert": "",
              "triggered": ""
            },  
            "pos_alert": {
              "activated": "",
              "threshold": "",
              "sup_or_inf": "",
              "delay": "",
              "trig_duration": "",
              "rest_duration": "",
              "last_alert": "",
              "triggered": ""
            },              
  	        'PR_alert': {
  	          "activated": "",
  	          "threshold": "",
  	          "sup_or_inf": "",
  	          "delay": "",
              "trig_duration": "",
              "rest_duration": "",
  	          "last_alert": "",
  	          "triggered": "",
  	          "threshold_exceeded_count": "",
  	          "threshold_exceedance_window": "",
  	          "threshold_exceedance_period": "",
  	          "last_period_alert": ""
  	        },
            'SPO2_alert':  {
              "activated": "",
              "threshold": "",
              "sup_or_inf": "",
              "delay": "",
              "trig_duration": "",
              "rest_duration": "",
              "last_alert": "",
              "triggered": "",
              "threshold_exceeded_count": "",
              "threshold_exceedance_window": "",
              "threshold_exceedance_period": "",
              "last_period_alert": ""
            },
            'bloodpressure_PR_alert': {
              "activated": "",
              "threshold": "",
              "sup_or_inf": "",
              "delay": "",
              "trig_duration": "",
              "rest_duration": "",
              "last_alert": "",
              "triggered": "",
              "threshold_exceeded_count": "",
              "threshold_exceedance_window": "",
              "threshold_exceedance_period": "",
              "last_period_alert": ""
            },
            'bloodpressure_sys_high_alert':  {
              "activated": "",
              "threshold": "",
              "sup_or_inf": "",
              "delay": "",
              "trig_duration": "",
              "rest_duration": "",
              "last_alert": "",
              "triggered": "",
              "threshold_exceeded_count": "",
              "threshold_exceedance_window": "",
              "threshold_exceedance_period": "",
              "last_period_alert": ""
            },
            'bloodpressure_dia_alert':  {
              "activated": "",
              "threshold": "",
              "sup_or_inf": "",
              "delay": "",
              "trig_duration": "",
              "rest_duration": "",
              "last_alert": "",
              "triggered": "",
              "threshold_exceeded_count": "",
              "threshold_exceedance_window": "",
              "threshold_exceedance_period": "",
              "last_period_alert": ""
            },
            'weight_alert':  {
              "activated": "",
              "threshold": "",
              "sup_or_inf": "",
              "delay": "",
              "trig_duration": "",
              "rest_duration": "",
              "last_alert": "",
              "triggered": "",
              "threshold_exceeded_count": "",
              "threshold_exceedance_window": "",
              "threshold_exceedance_period": "",
              "last_period_alert": ""
            },
            'breathing_rate_alert':  {
              "activated": "",
              "threshold": "",
              "sup_or_inf": "",
              "delay": "",
              "trig_duration": "",
              "rest_duration": "",
              "last_alert": "",
              "triggered": "",
              "threshold_exceeded_count": "",
              "threshold_exceedance_window": "",
              "threshold_exceedance_period": "",
              "last_period_alert": ""
            },
            'breathing_oxygen_rate_alert':  {
              "activated": "",
              "threshold": "",
              "sup_or_inf": "",
              "delay": "",
              "trig_duration": "",
              "rest_duration": "",
              "last_alert": "",
              "triggered": "",
              "threshold_exceeded_count": "",
              "threshold_exceedance_window": "",
              "threshold_exceedance_period": "",
              "last_period_alert": ""
            },
            'breathing_leakage_alert':  {
              "activated": "",
              "threshold": "",
              "sup_or_inf": "",
              "delay": "",
              "trig_duration": "",
              "rest_duration": "",
              "last_alert": "",
              "triggered": "",
              "threshold_exceeded_count": "",
              "threshold_exceedance_window": "",
              "threshold_exceedance_period": "",
              "last_period_alert": ""
            },
            'breathing_observance_alert':  {
              "activated": "",
              "threshold": "",
              "sup_or_inf": "",
              "delay": "",
              "trig_duration": "",
              "rest_duration": "",
              "last_alert": "",
              "triggered": "",
              "threshold_exceeded_count": "",
              "threshold_exceedance_window": "",
              "threshold_exceedance_period": "",
              "last_period_alert": ""
            },
            "mail_alert": "",
            "sms_alert": "",
            "mail_alert_reminder": "",
            "sms_alert_reminder": "",
            "mail_alert_night": "",
            "sms_alert_night": "",
            "mail_alert_reminder_night": "",
            "sms_alert_reminder_night": "",
            "sound_alert": null
      },
      // ******************************** //
      // OBSERVATIONS
      'thermometer' : [],
      'pulseOximeter': {
        'pulseRate': [],
        'SPO2': []
      },
      'pulseTensiometer': {
        'pulseRate': [],
        'systolic': []
      },
      'pain' : [],
      'scale_data': {
        'weight': []
      },
      'eq5d': {
        'form_res': [],
        'healthscale': []
      },
      'mdasi': {
        'form_res': []
      },
      'sf36': {
        'form_res': []
      },
      'alimentation': {
        'form_res': []
      },
      'kidney_device': {
        'form_res': []
      },
      'kidney_blood': {
        'form_res': []
      },
      'breathing': {
        'niv_schedule': [],
        'niv_usage': [],
        'oxi_schedule': [],
        'oxi_usage': [],
        'respiratory_rate': [],
        'respiratory_leak': [],
        'oxygen_flow_rate': []
      },
      'photo': [
      ]
      // ******************************** //
        }
    }                               

    return (default_patient);

}

//Export functions to make them visible and usable in other files
const DefaultPatient = {
    getPatientDefaultParams
};

export default DefaultPatient;